import { IconProps } from "./";
import Icon from "./assets/pause_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Pause(props: IconProps) {
  return <BaseIcon className="text-6xl" icon={<Icon />} {...props} />;
}
